<template>
    <Head>
        <title>Wakaf Pahang - Senarai Laporan</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <section ref="header" id="abc" class="container-fluid py-4 position-fixed top-0 bg-wakaf-primary" style="z-index: 5">
        <div class="row">
            <h1 class="fs-3 text-center text-white animate__animated" :class="{animate__bounceIn: displayAnimateTitle}"><font-awesome-icon :icon="faChartColumn" /> {{modalTitle}}</h1>
        </div>
    </section>
    <section ref="containerMargin" class="container-fluid overflow-hidden">
        <section :class="{ hideMenu: showReport, showMenu: hideReport, 'd-none': mainMenuHideSwitch  }">
            <div class="row gx-2">
                <div class="col">
                    <div class="p-3 bg-wakaf-primary rounded">
                        <div class="d-flex justify-content-center">
                        <p class="border border-3 rounded-3 border-wakaf-secondary text-wakaf-secondary fs-5 fw-bold p-2 text-center"><font-awesome-icon :icon="faChartArea" /> Statistik keseluruhan</p>
                    </div>
                        <div class="d-flex flex-wrap gap-3 justify-content-center mt-3">
                        <button type="button" class="btn btn-outline-wakaf-secondary p-3" @click="openLinks('baru')">
                            Transaksi dan bilangan pewakaf
                        </button>
                        <button type="button" class="btn btn-outline-wakaf-secondary p-3" @click="openLinks('pgw')">
                            Senarai pewakaf baru bulanan <b>(PGW)</b>
                        </button>

                        <button type="button" class="btn btn-outline-wakaf-secondary p-3" @click="openLinks('transaction')">
                            Senarai transaksi wakaf
                        </button>
                    </div>
                    </div>
                </div>
                <div class="col">
                    <div class="p-3 bg-wakaf-secondary rounded">
                        <div class="d-flex justify-content-center">
                            <p class="border border-3 rounded-3 border-wakaf-primary text-wakaf-primary fs-5 fw-bold p-2 text-center"><font-awesome-icon :icon="faChartArea" />  Mengikut kaunter</p>
                        </div>
                        <div class="d-flex flex-wrap gap-3 justify-content-center mt-3">
                        <button type="button" class="btn btn-outline-wakaf-primary p-3" @click="openLinks('kaunter-bulan')">
                            Laporan kutipan mengikut kaunter - bulan
                        </button>
                        <button type="button" class="btn btn-outline-wakaf-primary" @click="openLinks('kaunter-DaerahPewakaf')">
                            Laporan kutipan mengikut kaunter - daerah pewakaf
                        </button>
                        <button type="button" class="btn btn-outline-wakaf-tertiary p-3 fw-bolder fst-italic" @click="openLinks('projek-kaunter-ringkasan')">
                            Ringkasan kaunter - projek
                        </button>
                    </div>
                    </div>
                </div>
                <div class="col">
                    <div class="p-3 bg-wakaf-primary rounded">
                        <div class="d-flex justify-content-center">
                            <p class="border border-3 rounded-3 border-wakaf-secondary text-wakaf-secondary fs-5 fw-bold p-2 text-center"><font-awesome-icon :icon="faChartArea" />   Mengikut daerah</p>
                        </div>
                        <div class="d-flex flex-wrap gap-3 justify-content-center mt-3">
                            <button type="button" class="btn btn-outline-wakaf-secondary p-3" @click="openLinks('daerahPewakaf-bulan')">
                                Laporan kutipan mengikut daerah pewakaf - bulan
                            </button>
                            <button type="button" class="btn btn-outline-wakaf-secondary p-3" @click="openLinks('daerahWakaf-bulan')">
                                Laporan kutipan mengikut daerah wakaf - bulan
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="p-3 bg-wakaf-secondary rounded">
                        <div class="d-flex justify-content-center">
                            <p class="border border-3 rounded-3 border-wakaf-primary text-wakaf-primary fs-5 fw-bold p-2 text-center"><font-awesome-icon :icon="faChartArea" />   Mengikut projek</p>
                        </div>
                        <div class="d-flex flex-wrap gap-3 justify-content-center mt-3">
                            <button type="button" class="btn btn-outline-wakaf-primary p-3" @click="openLinks('projek-bulan')">
                                Laporan kutipan mengikut projek - bulan
                            </button>
                            <button type="button" class="btn btn-outline-wakaf-primary p-3" @click="openLinks('projek-kaunter')">
                                Laporan kutipan mengikut projek - kaunter
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </section>
        <section ref="rpt" :class="{ hideReport: hideReport, showReport: showReport, 'd-none': !mainMenuHideSwitch}">
            <transaction :csrf="csrf" @hide-page="hideAllComponents" @show-modal="showModal" @hide-loader="hideLoader" :kodPegawai="kodPegawai"
                         @show-loader="showLoader" :uri_get_transactions="uri_get_transactions" :uri_get_modal="uri_get_modal" :uri_kodbank="uri_kodbank"
                         v-if="switchView.transaction"></transaction>
            <kaunter-daerah-pewakaf @hide-page="hideAllComponents" @hide-loader="hideLoader"
                                  :uri_get_kaunter_daerah="uri_get_kaunter_daerah_pewakaf" :year="year" :month="month"
                                  :uri_download_report_kaunter_daerah_pewakaf="uri_download_report_kaunter_daerah_pewakaf"
                                  :csrf="csrf" @show-loader="showLoader"
                                  v-if="switchView.kaunterDaerahPewakaf"></kaunter-daerah-pewakaf>
            <daerah-pewakaf-bulan @hide-page="hideAllComponents" @hide-loader="hideLoader" @show-loader="showLoader"
                                :uri_get_daerahpewakaf_bulan="uri_get_daerahpewakaf_bulan" :uri_download_report_daerahpewakaf_bulan="uri_download_report_daerahpewakaf_bulan"
                                :year="year" :csrf="csrf" v-if="switchView.daerahPewakafbulan"></daerah-pewakaf-bulan>
            <daerah-wakaf-bulan @hide-page="hideAllComponents" @hide-loader="hideLoader" @show-loader="showLoader"
                              :uri_get_daerah_wakaf_bulan="uri_get_daerah_wakaf_bulan" :uri_download_report_daerahwakaf_bulan="uri_download_report_daerahwakaf_bulan" :year="year" :csrf="csrf"
                              v-if="switchView.daerahWakafbulan"></daerah-wakaf-bulan>
            <kaunter-bulan @hide-page="hideAllComponents" :csrf="csrf" :year="year" @hide-loader="hideLoader"
                           :uri_get_kaunter_bulan="uri_get_kaunter_bulan" :uri_download_report_kaunter_bulan="uri_download_report_kaunter_bulan" @show-loader="showLoader"
                           v-if="switchView.kaunterBulan"></kaunter-bulan>
            <kaunter-projek-ringkasan @hide-page="hideAllComponents" :uri_get_projek_kaunter_ringkasan="uri_get_projek_kaunter_ringkasan" :year="year" v-if="switchView.kaunterProjekRingkasan" :uri_download_projek_kaunter_ringkasan="uri_download_projek_kaunter_ringkasan"
                                      :month="month" @show-loader="showLoader" @hide-loader="hideLoader" :csrf="csrf"></kaunter-projek-ringkasan>
            <projek-bulan @hide-page="hideAllComponents" @show-loader="showLoader" :csrf="csrf" :year="year" @hide-loader="hideLoader"
                          :uri_get_projek_bulan="uri_get_projek_bulan" :uri_download_report_projekwakaf_bulan="uri_download_report_projekwakaf_bulan"
                          v-if="switchView.projekBulan"></projek-bulan>
            <projek-kaunter @hide-page="hideAllComponents" :csrf="csrf" :year="year" :month="month" :uri_download_report_projekwakaf_kaunter="uri_download_report_projekwakaf_kaunter"
                            :uri_get_projek_kaunter="uri_get_projek_kaunter" @hide-loader="hideLoader" @show-loader="showLoader"
                            v-if="switchView.projekKaunter"></projek-kaunter>
            <pewakaf-baru @hide-page="hideAllComponents" :uri_get_pewakaf_office="uri_get_pewakaf_office" :uri_get_pewakaf_project="uri_get_pewakaf_project" :year="year" :month="month"
                          v-if="switchView.pewakafBaru" @hide-loader="hideLoader" @show-loader="showLoader" :uri_download_report_pejabat="uri_download_report_pejabat" :uri_download_report_project="uri_download_report_project"
                          :csrf="csrf"></pewakaf-baru>
            <pewakaf-p-g-w @hide-page="hideAllComponents" :uri_get_pgw="uri_get_pgw" :year="year" v-if="switchView.pgw" :uri_download_report_pgw="uri_download_report_pgw"
                           @show-loader="showLoader" @hide-loader="hideLoader" :csrf="csrf"></pewakaf-p-g-w>
        </section>
    </section>
    <div class="position-fixed" :class="{ 'd-none': !isDisplayLoader}" style="top: 0; inset: 0 0 0 0; background-color: rgba(255, 255, 255, 0.6); z-index: 5"></div>
    <div class="loader-cover" :class="{ 'd-none': !isDisplayLoader}"></div>
    <div class="loader" :class="{ 'd-none': !isDisplayLoader}"></div>
    <Modal ref="modalWakaf">
        <template #Header>
            <div class="d-flex justify-content-between mb-2">
                <p class="fs-3">Maklumat pewakaf bagi {{ modalName}} dari daerah {{ modalDaerah }}</p>
                <button type="button" @click="closeModal" class="btn"><font-awesome-icon :icon="faXmark" /></button>
            </div>
        </template>
        <template #Body>
            <div class="table-responsive" :class="[custom.popupBody]">
                <table class="table">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Jenis Wakaf</th>
                        <th scope="col">Keterangan</th>
                        <th scope="col">Unit</th>
                        <th scope="col">Nama</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(transaction, index) in modalTableTransactions">
                        <td>{{ index+1 }}</td>
                        <td>{{transaction.jenisWakaf}}</td>
                        <td>{{ transaction.daerah + " - "+transaction.namaProjek }}</td>
                        <td>{{ transaction.unit }}</td>
                        <td>{{ ((transaction.jenisPemilikan === "Mewakili Orang Meninggal")? "Arwah ":"").concat(transaction.pemilikWakaf) }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template #Footer>
            <div class="d-flex justify-content-end">
                <a @click="closeModal" type="button" class="btn btn-danger me-2" data-bs-dismiss="modal"><font-awesome-icon :icon="faXmark" /> Tutup
                </a>
                <a class="btn btn-warning" target="_blank" rel="noreferrer noopener" id="link" :href="modalPrintLink"
                ><font-awesome-icon :icon="faPrint" />  Cetak</a>
            </div>
        </template>
    </Modal>
</template>

<script setup lang="ts">
import {onMounted, Ref, ref} from "vue";
import { Head } from "@inertiajs/vue3";
import custom  from "../../../scss/app.module.scss";
import {transactionModalData} from "../interface/transactionModalData";
import {transactionData} from "../interface/transactionData";
import Modal from "../../components/modal.vue";
import "animate.css";
import { faChartArea, faChartColumn, faPrint, faXmark} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faChartColumn, faChartArea, faPrint, faXmark);

import Transaction from "./transaction.vue";
import ProjekKaunter from "./projekKaunter.vue";
import ProjekBulan from "./projekBulan.vue";
import KaunterBulan from "./kaunterBulan.vue";
import DaerahWakafBulan from "./daerahWakafBulan.vue";
import DaerahPewakafBulan from "./daerahPewakafBulan.vue";
import KaunterDaerahPewakaf from "./kaunterDaerahPewakaf.vue";
import PewakafPGW from "./pewakafBaruBulananPGW.vue";
import PewakafBaru from "./pewakafBaruBulanan.vue";
import KaunterProjekRingkasan from "./kaunterProjekRingkasan.vue";


const rpt: Ref = ref<HTMLDivElement>();
const header: Ref = ref<HTMLDivElement>();
const containerMargin: Ref = ref<HTMLDivElement>();
const isDisplayLoader: Ref = ref<boolean>(false);
const data = defineProps<{
    csrf: string,
    img_favicon: string,
    uri_get_pewakaf_office: string,
    uri_download_report_pejabat: string,
    uri_get_pewakaf_project: string,
    uri_download_report_project: string,
    uri_get_pgw: string,
    uri_download_report_pgw: string,
    uri_get_kaunter_daerah_pewakaf: string,
    uri_download_report_kaunter_daerah_pewakaf: string,
    uri_get_transactions: string,
    uri_get_modal: string,
    uri_get_daerahpewakaf_bulan: string,
    uri_download_report_daerahpewakaf_bulan: string,
    uri_get_daerah_wakaf_bulan: string,
    uri_download_report_daerahwakaf_bulan: string,
    uri_get_kaunter_bulan: string,
    uri_download_report_kaunter_bulan: string,
    uri_get_projek_bulan: string,
    uri_download_report_projekwakaf_bulan: string,
    uri_get_projek_kaunter: string,
    uri_download_report_projekwakaf_kaunter: string,
    uri_get_projek_kaunter_ringkasan: string,
    uri_download_projek_kaunter_ringkasan: string,
    uri_kodbank: string,
    kodPegawai: string,
    year: number,
    month: number,
}>();

onMounted(()=>{
    recalculateMargin();
       // header.value!.clientHeight + 10 +"px";
    window.addEventListener("resize", ()=>{
        recalculateMargin();
    });
    if(window.location.hash.split("#")[1] !== undefined){
        openLinks(window.location.hash.split("#")[1]);
    }
});
const modalTitle = ref<string>("Menu Laporan wakaf");
const displayAnimateTitle = ref<boolean>(true);

const showReport = ref<boolean>(false);
const hideReport = ref<boolean>(true);
const mainMenuHideSwitch = ref<boolean>(false);
const modalName = ref<string>("");
const modalDaerah = ref<number>(0);
const modalPrintLink = ref<string>("");
const modalTableTransactions = ref<transactionData[]>();
const modalWakaf = ref<InstanceType<typeof Modal> | null>(null);
const switchView = ref<{
    "pewakafBaru": boolean,
    "pgw": boolean,
    "kaunterDaerahPewakaf": boolean,
    "kaunterBulan": boolean,
    "kaunterProjekRingkasan": boolean,
    "daerahPewakafbulan": boolean,
    "daerahWakafbulan": boolean,
    "projekBulan": boolean,
    "projekKaunter": boolean,
    "transaction": boolean,
}>({
    "pewakafBaru": false,
    "pgw": false,
    "kaunterDaerahPewakaf": false,
    "kaunterBulan": false,
    "kaunterProjekRingkasan": false,
    "daerahPewakafbulan": false,
    "daerahWakafbulan": false,
    "projekBulan": false,
    "projekKaunter": false,
    "transaction": false,
});


const openLinks = (sw: string) => {
    let titleRpt: string;
    isDisplayLoader.value = true;
    displayAnimateTitle.value = false;

    switch (sw) {
        case "baru" :
            titleRpt = "Transaksi dan bilangan pewakaf";
            switchView.value.pewakafBaru = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#baru";
            break;
        case "pgw" :
            titleRpt = "Senarai potongan gaji wakaf (PGW) terbaru bulanan";
            switchView.value.pgw = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#pgw";
            break;
        case "kaunter-DaerahPewakaf" :
            titleRpt = "Laporan kutipan kaunter - daerah pewakaf";
            switchView.value.kaunterDaerahPewakaf = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#kaunter-DaerahPewakaf";
            break;
        case "daerahWakaf-bulan" :
            titleRpt = "Laporan kutipan daerah wakaf - bulan (transaksi)";
            switchView.value.daerahWakafbulan = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#daerahWakaf-bulan";
            break;
        case "daerahPewakaf-bulan" :
            titleRpt = "Laporan kutipan daerah pewakaf - bulan";
            switchView.value.daerahPewakafbulan = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#daerahPewakaf-bulan";
            break;
        case "kaunter-bulan" :
            titleRpt = "Laporan kutipan kaunter - bulan (transaksi)";
            switchView.value.kaunterBulan = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#kaunter-bulan";
            break;
        case "projek-bulan" :
            titleRpt = "Laporan kutipan projek wakaf - bulan (transaksi)";
            switchView.value.projekBulan = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#projek-bulan";
            break;
        case "projek-kaunter" :
            titleRpt = "Laporan kutipan projek wakaf - kaunter";
            switchView.value.projekKaunter = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#projek-kaunter";
            break;
        case "projek-kaunter-ringkasan" :
            titleRpt = "Ringkasan kutipan projek - kaunter";
            switchView.value.kaunterProjekRingkasan = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#projek-kaunter-ringkasan";
            break;
        case "transaction":
            titleRpt = "Laporan Transaksi Wakaf";
            switchView.value.transaction = true;
            showReport.value = true;
            hideReport.value = false;
            window.location.hash = "#transaction";
            break;
    }
    setTimeout(()=>{
        modalTitle.value = titleRpt;
        displayAnimateTitle.value = true;
        mainMenuHideSwitch.value = true;
        setTimeout(()=>{
            recalculateMargin();
        },10);

    },1000);
}
const hideAllComponents = () => {
    displayAnimateTitle.value = false;
    setTimeout(()=>{
        switchView.value.pewakafBaru = false;
        switchView.value.pgw = false;
        switchView.value.kaunterDaerahPewakaf = false;
        switchView.value.kaunterProjekRingkasan = false;
        switchView.value.daerahPewakafbulan = false;
        switchView.value.daerahWakafbulan = false;
        switchView.value.kaunterBulan = false;
        switchView.value.projekBulan = false;
        switchView.value.transaction = false;
        switchView.value.projekKaunter = false;
        modalTitle.value = "Menu laporan wakaf";
        displayAnimateTitle.value = true;
        mainMenuHideSwitch.value = false;
        setTimeout(()=>{
            recalculateMargin();
        },10);
    },1000);
    hideReport.value = true;
    showReport.value =false;
    history.replaceState(null, "", ' ');
}

const showModal = (modalData: transactionModalData) : void =>{
    modalTableTransactions.value = modalData.transaction;
    modalName.value = modalData.nama;
    modalDaerah.value = modalData.daerah;
    modalPrintLink.value = modalData.printLink;
    modalWakaf.value?.showModal();
}
const closeModal = () : void =>{
    modalWakaf.value?.closeModal();
}
const hideLoader = () : void =>{
    isDisplayLoader.value = false;
}
const showLoader = () : void =>{
    isDisplayLoader.value = true;
}
const recalculateMargin = () : void =>{
    containerMargin.value!.style.marginTop = `${window.scrollY + header.value?.offsetHeight + 10}px`;
}
</script>

<style scoped>
.hideMenu{
    transform: translate3d(-110%, 0px, 0px);
    transition: transform 1s cubic-bezier(.98,-0.01,.63,1.01);
}
.showMenu{
    transform: translate3d(0px, 0px, 0px);
    transition: transform 1s cubic-bezier(.98,-0.01,.63,1.01);
}
.hideReport{
    transform: translate3d(110%, 0px, 0px);
    transition: transform 1s cubic-bezier(.98,-0.01,.63,1.01);
}
.showReport{
    transform: translate3d(0px, 0px, 0px);
    transition: transform 1s cubic-bezier(.98,-0.01,.63,1.01);
}

.loader {
    height: 10px;
    width: 100%;
    background: no-repeat linear-gradient(#5a1c50 0 0), no-repeat linear-gradient(#5a1c50 0 0), #d7b8fc;
    background-size: 60% 100%;
    animation: loader 3s infinite;
    position: fixed;
    bottom: 0;
    z-index: 7;
}
.loader-cover {
    height: 40px;
    width: 100%;
    background: no-repeat linear-gradient(#5a1c50 0 0), no-repeat linear-gradient(#5a1c50 0 0), #ffffff;
    background-size: 60% 100%;
    animation: loader 3s infinite;
    position: fixed;
    bottom: 10px;
    z-index: 6;
    opacity: 0.15;
    filter: blur(10px);
}

@keyframes loader {
    0%   {
        background-position:-150% 0,-150% 0;
    }
    66%  {
        background-position: 250% 0,-150% 0;
    }
    100% {
        background-position: 250% 0, 250% 0;
    }
}
</style>
